module.exports = __webpack_public_path__ + "img/img6.e71cee5f.svg";